import AttestationRepository, {IAttestationRepository} from "../repositories/attestation";

// delete after backend's fix start
import {mockList} from './tests/mock';

//@ts-expect-error
const fullfilllTestLastSubmition = attestation => {
    if (attestation.lastSubmition) {
        return attestation;
    }
    const lastSubmission  = mockList[attestation.id];
    if (lastSubmission) {
        return {
            ...attestation,
            lastSubmission,
        }
    }
    return attestation;
}
// delete after backend's fix end

export class AttestationsService {
    private repository: IAttestationRepository;
    constructor(repositoryInstance: IAttestationRepository) {
        this.repository = repositoryInstance;
    }

    async getAttestations(userId: string) {
        const attestationsList = await this.repository.getAttestations(userId);
        return attestationsList.map(fullfilllTestLastSubmition);
    }

    getAttestationsSubmission(attestationId: string) { 
        return this.repository.getAttestationsSubmission(attestationId);
    }

    //@ts-expect-error
    submitAttestation(attestationId: string, answers) {
        return this.repository.submitAttestation(attestationId, answers);
    }

    getStatistic(alias: string) {
        return this.repository.getStatistic(alias);
    }
}

const attestationsService = new AttestationsService(new AttestationRepository());

export default attestationsService;